import { useTranslation } from 'react-i18next';

import { Stack, Typography } from '@mui/material';

import Tag from '../../../components/Tag';
import { ClassListItem } from '../../../db/classes/types';
import { i18nNS } from '../../../i18n';
import { format, formatDistanceToNow } from '../../../utils/datetime';
import { Root } from './styles';

interface ClassListItemWithActivities {
  type: 'activities';
  numActivities: ClassListItem['numActivities'];
}
interface ClassListItemWithAttendance {
  type: 'attendance';
  markedInStudents: number;
}

export type ClassWidgetProps = DistributiveOmit<ClassListItem, 'numActivities'> &
  (ClassListItemWithActivities | ClassListItemWithAttendance) & {
    className?: string;
  };

const ClassWidget = ({ startTime, isIncharge, className, ...props }: ClassWidgetProps) => {
  const { t } = useTranslation([i18nNS.CLASS]);

  return (
    <Root className={className}>
      <Stack direction="row" alignItems="center" gap={1.25} px={1.25} py={0.5}>
        <Typography flex={1} variant="paragraphBold" component="h6">
          {format(startTime, "do MMM, yyyy 'at' hh:mm a")}
        </Typography>
        {isIncharge && (
          <Tag variant="outlined" color="primary" label={t('class_in_charge', { ns: i18nNS.CLASS })} />
        )}
      </Stack>
      {props.type === 'activities' ? (
        <Typography variant="paragraphRegular" noWrap p={1.25}>
          {t('N_planned_polls', { ns: i18nNS.CLASS, count: props.numActivities.polls })}
        </Typography>
      ) : (
        <Typography variant="paragraphRegular" noWrap p={1.25}>
          {props.markedInStudents == null
            ? t('D_from_now', {
                ns: i18nNS.CLASS,
                distance: formatDistanceToNow(startTime, { addSuffix: false, includeSeconds: true }),
              })
            : t('N_marked_present', { ns: i18nNS.CLASS, count: props.markedInStudents })}
        </Typography>
      )}
    </Root>
  );
};

export default ClassWidget;
